import React, { useContext, useEffect, useState } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormControlLabel, Grid, IconButton, Button, Typography, LinearProgress, Switch, TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import DialogContent from '@material-ui/core/DialogContent';
import ReactTooltip from "react-tooltip";
import * as actions from "../actions/actions";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles((theme) => ({
  popupButton: {
    justifyContent: "center"
  },
  textarea: {
    background: "transparent",
    resize: "none",
    border: "1px solid #AAAAAA",
    width: 550,
    outline: "none",
    height: 200,  // textarea rounds up to next line height, so make sure not to display scroll bars if empty
    fontFamily: "inherit",
    fontSize: "inherit",
  },
}));

export default function PasteDialog() {
  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);
  const classes = useStyles();
  const [confirmed, setConfirmed] = useState(false);
  const [textContent, setTextContent] = useState("");
  const [optionState, setOptionState] = useState(false);

  const { onConfirm, onCancel, payload, title, description, hint, placeholder, prefill, visible, waitingMessage, okLabel, cancelLabel, useArea, option } = state.ui.pasteDialog;

  useEffect(() => {
    setConfirmed(false);
    setTextContent(prefill || "");
  }, [state.ui.pasteDialog.visible, state.ui.pasteDialog.prefill]);

  

  const handleConfirm = () => {
    if (!waitingMessage) {
      dispatch(actions.closePasteDialog());
    }
    setConfirmed(true);
    onConfirm && onConfirm(payload, textContent, optionState);
  }

  const handleCancel = () => {
    dispatch(actions.closePasteDialog());
    onCancel && onCancel(payload);
  }

  const onTextChanged = (text) => {
    setTextContent(text);
  }

  return (
    <Dialog maxWidth="sm" scroll="paper" onClose={handleCancel} open={visible}>
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent dividers>
          <Grid container direction="column">
            {description && <Typography>{description}</Typography>}
            {hint && (<Typography style={{marginTop: 8}} variant="body2" color="secondary">{hint}</Typography>)}
            {useArea ?  
              <textarea style={{ marginTop: 15, marginBottom: 15 }} className={classes.textarea}
                value={textContent}
                placeholder={placeholder}
                onChange={(e) => { onTextChanged(e.target.value) }} />
               : 
                <TextField style={{ width: 500, marginTop: 15, marginBottom: 15 }}
                value={textContent}
                placeholder={placeholder}
                onChange={(e) => { onTextChanged(e.target.value) }} />
            }
            {option && 
              <FormControlLabel  control={<Switch />} label={option.label} checked={optionState} onChange={(e) => setOptionState(e.target.checked)}/>                
            }
            {waitingMessage && confirmed && <><Typography variant="body2" color="secondary">{waitingMessage}</Typography>
            <LinearProgress style={{ width: "100%" }} /></>}
            </Grid>
      </DialogContent>
      <DialogActions className={classes.popupButton} >
        {onConfirm && <Button disabled={confirmed || !textContent.length} variant="contained" color="primary" onClick={handleConfirm}>
          {okLabel ? okLabel : s.yes}
        </Button>}
        <Button disabled={confirmed} variant="outlined" color="primary" onClick={handleCancel}>
          {cancelLabel ? cancelLabel : onConfirm ? s.common.no : s.common.ok}
        </Button>
      </DialogActions>
    </Dialog>
  )
}